/** The editor tray's widths, and the room the stage has to leave for it (`WEB-012`). */

/** The panel column, which never collapses. The one part of the tray the stage always gives up. */
export const PANEL_COLUMN_PX = 48;

/** The body docked, and the wide body Composition asks for. Both from the space-editor brief. */
export const TRAY_BODY_PX = 360;
export const TRAY_BODY_WIDE_PX = 560;

/** How wide the popped-out body draws, or zero while it is shut. */
export function trayBodyWidth(open: boolean, wide: boolean): number {
  if (!open) return 0;
  return wide ? TRAY_BODY_WIDE_PX : TRAY_BODY_PX;
}

/** How much of the editor's width the stage keeps clear on its right, so nothing is covered. */
export function stageInset(open: boolean, wide: boolean): number {
  return PANEL_COLUMN_PX + trayBodyWidth(open, wide);
}
